export default __webpack_public_path__ + "static/media/Inter-Medium.3f7acfe5.ttf";